import axios from 'axios';
import { store } from '../store';
import { refreshTokenInterceptor } from './interceptors/refreshToken.interceptor';

const create = () => {
  const { token, refreshToken } = store.getState().auth;
  const { user } = store.getState().me;
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://api.revaluex.io',
    headers: { Authorization: `Bearer ${token}` },
  });

  instance.interceptors.response.use((response) => {
    return response;
  }, refreshTokenInterceptor(instance, refreshToken, user!));

  return instance;
};

export default create;
